export default {
    name: 'SubItems',
    functional: true,
    render(createElement, { props }) {
        const Item = require('./Item.js').default;
        const itemElements = props.items.map((item) => createElement(Item, {
            props: {
                item,
                resource: props.resource,
            },
        }));
        return itemElements;
    },
};
